<template>
  <div class="container-fluid" >
    <div class="row">
        <div class="header-logo">
            <img :src="$img('logo.png')" />
            <svg-item class="backButton" @click.native="onBackClick" size="42" :color="'--main-color'" :icon="'volver'"></svg-item>
        </div>
        <div class="col-xs-24">
            <div class="col-container">
                <h1 v-lang.newAccount v-if="!success"> Crear una cuenta</h1>
                <h1 v-lang.registerSuccess  v-else>¡Registro Exitoso! </h1>
                <div id='form' class='form row' v-if="!success">
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_name" v-lang.name>Nombre</label>
                        <input v-jump:focus="'txt_surename'" ref="txt_name" class="form-input" maxlength="25" type="text" id="txt_name" v-model='name' :class="{'has-error': nombreError.state }"/>
                        <span class="error" v-if="nombreError.state"> {{nombreError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_surename" v-lang.sureName>Apellido</label>
                        <input v-jump:focus="'txt_email'" class="form-input" ref="txt_surename" maxlength="25" type="text" id="txt_surename" v-model='sureName' :class="{'has-error': apellidoError.state }"/>
                        <span class="error" v-if="apellidoError.state"> {{apellidoError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_email" v-lang.mail>Email</label>
                        <input v-jump:focus="'txt_reg_password'" class="form-input" ref="txt_email" maxlength="40" type="text" id="txt_email" v-model='email' :class="{'has-error': emailError.state }"/>
                        <span class="error" v-if="emailError.state"> {{emailError.message}} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.solicitar_telefono_pasajeros">
                        <label class="form-label" for="txt_telefono">{{ settings.solicitar_telefono_pasajeros && settings.solicitar_telefono_pasajeros.label ? settings.solicitar_telefono_pasajeros.label : translate('telefono') }}</label>
                        <input v-jump:focus="'txt_reg_password'" class="form-input" ref="txt_telefono" maxlength="40" type="number" id="txt_telefono" v-model='telefono' :class="{'has-error': telefonoError.state }"/>
                        <span class="error" v-if="telefonoError.state"> {{telefonoError.message}} </span>
                        <span class="help" v-if="settings.solicitar_telefono_pasajeros && settings.solicitar_telefono_pasajeros.help"> {{ settings.solicitar_telefono_pasajeros.help }} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_reg_password" v-lang.registerPassword>Contraseña</label>
                        <div class="password-input-inner">
                            <input v-jump:focus="'txt_password_confirmation'" class="form-input" ref="txt_reg_password" maxlength="40" :type="showRegPassword ? 'text' : 'password'" id="txt_reg_password" v-model='password' :class="{'has-error': passwordError.state }"/>
                            <button type="button" class="password-toggle-btn" @click="showRegPassword = !showRegPassword" :aria-label="showRegPassword ? translate('hidePassword') : translate('showPassword')">
                                <svg-item v-if="!showRegPassword" :size="22" :icon="'ojo'" :color="'--text-color'"></svg-item>
                                <svg-item v-else :size="22" :icon="'ojo-cerrado'" :color="'--text-color'"></svg-item>
                            </button>
                        </div>
                        <span class="error" v-if="passwordError.state"> {{passwordError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_password_confirmation" v-lang.repeatPassword>Ingrese nuevamente su contraseña</label>
                        <div class="password-input-inner">
                            <input v-jump:focus="jumpRefAfterPasswordConfirm" class="form-input" ref="txt_password_confirmation" maxlength="40" :type="showRegPasswordConfirm ? 'text' : 'password'" id="txt_password_confirmation" v-model='passwordConfirmation' :class="{'has-error': passwordError.state }" />
                            <button type="button" class="password-toggle-btn" @click="showRegPasswordConfirm = !showRegPasswordConfirm" :aria-label="showRegPasswordConfirm ? translate('hidePassword') : translate('showPassword')">
                                <svg-item v-if="!showRegPasswordConfirm" :size="22" :icon="'ojo'" :color="'--text-color'"></svg-item>
                                <svg-item v-else :size="22" :icon="'ojo-cerrado'" :color="'--text-color'"></svg-item>
                            </button>
                        </div>
                        <span class="error" v-if="passwordError.state"> {{passwordError.message}} </span>
                    </div>

                    <div class="form-input-wrapper" v-if="settings.modulo_descuento_residente_jubilado">
                        <h2 class="form-label beneficio-registro-title">{{ translate('beneficioResidenteJubiladoTitulo') }}</h2>
                        <p class="help">{{ translate('beneficioResidenteJubiladoAyuda') }}</p>
                        <label class="form-label" for="registro_tipo_beneficio">{{ translate('registerBeneficioPregunta') }}</label>
                        <select
                            ref="registro_tipo_beneficio"
                            id="registro_tipo_beneficio"
                            v-model="tipoBeneficioRegistro"
                            class="form-select"
                            :class="{'form-select--message-selected': tipoBeneficioRegistro === ''}"
                            v-jump:focus="jumpRefAfterTipoBeneficio"
                        >
                            <option value="" disabled class="form-select--message">{{ translate('registerBeneficioSeleccionar') }}</option>
                            <option value="ninguno">{{ translate('sinDescuentoBeneficio') }}</option>
                            <option value="residente">{{ translate('residente') }}</option>
                            <option value="jubilado">{{ translate('jubilado') }}</option>
                        </select>
                        <span class="error" v-if="beneficioRegistroError.state"> {{ beneficioRegistroError.message }} </span>
                    </div>

                    <div class="form-input-wrapper" v-if="langs.length > 1">
                        <label class="form-label" for="txt_lang" v-lang.language></label>
                        <select v-model='lang' id="txt_lang" ref="txt_lang" v-jump:click.blur="'btn_login'"  class="form-select">
                            <option v-for="l in langs" v-bind:value="l.key" v-bind:key="l.key">
                                {{ l.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-input-wrapper" v-if="zonas.length > 1">
                        <label for="select_zone" class="form-label" v-lang.zonas>Zona: </label>
                        <select v-jump:focus="'cbx_terms'" id="select_zone" ref="select_zone" class="form-select" v-model="selectedZone" :class="{'form-select--message-selected': selectedZone === 0}">
                            <option v-lang.zonaMensajeSeleccion :value="0" class="form-select--message"></option>
                            <option v-for="zona in zonas" :value="zona.id" :key="zona.id">
                                {{ zona.title }}
                            </option>
                        </select>
                        <span class="error" v-if="zonasError.state"> {{zonasError.message}} </span>
                    </div>
                    <div class="terms">
                        <input v-jump:click.blur="'btn_register'" type="checkbox" ref="cbx_terms" id="cbx_terms" v-model='termsAndConditions' />
                        <label class="form-label" for="cbx_terms"><router-link :to="{name: 'terms'}" v-lang.termsAndConditions>He leído y acepto los términos y condiciones</router-link></label>
                        <button @click="register" ref="btn_register" id="btn_register" class="btn btn-primary" :disabled="loading || !termsAndConditions"> <span v-if="!loading" v-lang.register> Crear cuenta </span> <loader :flag="loading"> </loader>  </button>
                    </div>
                </div>
                <div class="form row" v-else>
                    <p v-lang.registerMessage>Te hemos enviado un código de verificación a tu e-mail para que puedas activar tu cuenta y comenzar a compartir viajes. </p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '../../services/dialogs.js';
import bus from '../../services/bus-event';
import router from '../../router';
import Calendar from '../elements/Calendar';
import Error from '@/services/inputError';
import Forms from '../mixins/forms';
import availableLanguages from '@/services/language';

let emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export default {
    name: 'register',
    data () {
        return {
            selectedZone: 0,
            email: '',
            telefono: '',
            password: '',
            passwordConfirmation: '',
            showRegPassword: false,
            showRegPasswordConfirm: false,
            name: '',
            sureName: '',
            termsAndConditions: false,
            loading: false,
            success: false,
            emailError: new Error(),
            passwordError: new Error(),
            nombreError: new Error(),
            apellidoError: new Error(),
            zonasError: new Error(),
            telefonoError: new Error(),
            beneficioRegistroError: new Error(),
            tipoBeneficioRegistro: '',
            lang: 'es',
            langs: []
        };
    },
    computed: {
        ...mapGetters({
            checkLogin: 'auth/checkLogin',
            isMobile: 'device/isMobile',
            zonas: 'company/zonas',
            tempData: 'tempCache/registerData',
            settings: 'company/config'
        }),
        jumpRefAfterPasswordConfirm () {
            if (this.settings.modulo_descuento_residente_jubilado) {
                return 'registro_tipo_beneficio';
            }
            return this.jumpRefAfterTipoBeneficioCore;
        },
        jumpRefAfterTipoBeneficio () {
            return this.jumpRefAfterTipoBeneficioCore;
        },
        jumpRefAfterTipoBeneficioCore () {
            if (this.langs.length > 1) {
                return 'txt_lang';
            }
            if (this.zonas.length > 1) {
                return 'select_zone';
            }
            return 'cbx_terms';
        }
    },

    mounted () {
        this.language = this.$getLang();
        if (availableLanguages) {
            for (const key in availableLanguages) {
                if (availableLanguages.hasOwnProperty(key)) {
                    const element = availableLanguages[key];
                    if (key !== 'first') {
                        this.langs.push({
                            text: element.name_language,
                            key: key
                        });
                    }
                }
            }
        }
        this.lang = this.language;
        bus.on('back-click', this.onBackClick);
        if (this.tempData) {
            this.selectedZone = this.tempData.selectedZone;
            this.email = this.tempData.email;
            this.password = this.tempData.password;
            this.passwordConfirmation = this.tempData.passwordConfirmation;
            this.name = this.tempData.name;
            this.sureName = this.tempData.sureName;
            this.termsAndConditions = this.tempData.termsAndConditions;
            this.telefono = this.tempData.telefono;
            if (this.tempData.tipoBeneficioRegistro !== undefined) {
                this.tipoBeneficioRegistro = this.tempData.tipoBeneficioRegistro;
            }
        }
    },

    methods: {
        ...mapActions({
            doRegister: 'auth/register',
            doLogin: 'auth/login',
            saveViewData: 'tempCache/set',
            resetViewData: 'tempCache/reset'
        }),
        validate () {
            let globalError = false;
            if (this.email.length < 1) {
                this.emailError.state = true;
                this.emailError.message = this.translate('forgetMail');
                globalError = true;
            } else if (!emailRegex.test(this.email)) {
                this.emailError.state = true;
                this.emailError.message = this.translate('invalidMail');
                globalError = true;
            }

            if (this.password.length < 1) {
                this.passwordError.state = true;
                this.passwordError.message = this.translate('forgetPassword');
                globalError = true;
            } else if (this.password.length < 8) {
                this.passwordError.state = true;
                this.passwordError.message = this.translate('minCharsPassword');
                globalError = true;
            } else if (this.passwordConfirmation < 1) {
                this.passwordError.state = true;
                this.passwordError.message = this.translate('forgetPasswordConfirmation');
                globalError = true;
            } else if (this.password !== this.passwordConfirmation) {
                this.passwordError.state = true;
                this.passwordError.message = this.translate('differentPasswords');
                globalError = true;
            }

            if (this.name.length < 1) {
                this.nombreError.state = true;
                this.nombreError.message = this.translate('forgetName');
                globalError = true;
            }

            if (this.sureName.length < 1) {
                this.apellidoError.state = true;
                this.apellidoError.message = this.translate('forgetSureName');
                globalError = true;
            }
            if (this.settings.solicitar_telefono_pasajeros) {
                if (this.settings.solicitar_telefono_pasajeros.required && this.telefono.length < 1) {
                    this.telefonoError.state = true;
                    this.telefonoError.message = this.translate('forgetTelephone');
                    globalError = true;
                } else {
                    this.telefonoError.state = false;
                }
                if (this.settings.solicitar_telefono_pasajeros.regex && this.telefono.length > 0) {
                    let regex = new RegExp(this.settings.solicitar_telefono_pasajeros.regex);
                    if (!regex.test(this.telefono)) {
                        this.telefonoError.state = true;
                        this.telefonoError.message = this.translate('wrongTelephone');
                        globalError = true;
                    } else {
                        this.telefonoError.state = false;
                    }
                }
            }

            if (this.zonas.length > 1 && this.selectedZone === 0) {
                this.zonasError.state = true;
                this.zonasError.message = this.translate('notSelectedZone');
                globalError = true;
            }

            if (this.settings.modulo_descuento_residente_jubilado) {
                if (!this.tipoBeneficioRegistro || this.tipoBeneficioRegistro === '') {
                    this.beneficioRegistroError.state = true;
                    this.beneficioRegistroError.message = this.translate('registerBeneficioObligatorio');
                    globalError = true;
                } else {
                    this.beneficioRegistroError.state = false;
                }
            }

            return globalError;
        },
        register () {
            if (this.validate()) {
                this.jumpToError();
                return;
            }

            let email = this.email;
            let password = this.password;
            let passwordConfirmation = this.passwordConfirmation;
            let name = this.name;
            let sureName = this.sureName;
            let zonaId = this.zonas.length > 1 ? this.selectedZone : this.zonas[0].id;
            let termsAndConditions = this.termsAndConditions;
            let telefono = this.telefono;
            let lang = this.lang;
            let tipoBeneficio = (this.tipoBeneficioRegistro === 'residente' || this.tipoBeneficioRegistro === 'jubilado')
                ? this.tipoBeneficioRegistro
                : undefined;
            this.loading = true;
            this.doRegister({ email, password, passwordConfirmation, name, sureName, zonaId, termsAndConditions, telefono, lang, tipoBeneficio }).then((user) => {
                this.resetViewData({key: 'view', subKey: 'register'});
                if (this.langs.length > 1) {
                    this.$setLang(this.lang);
                }
                if (user.active) {
                    this.doLogin({email, password}).then(data => {
                    }).catch(() => {
                        dialogs.message('Ocurrió un error inesperado.', { duration: 10, estado: 'error' });
                        router.back();
                    });
                } else {
                    this.loading = false;
                    this.success = true;
                }
            }).catch((err) => {
                if (err && err.status === 422) {
                    dialogs.message(this.translate('inUseMail'), {estado: 'error'});
                    this.emailError.state = true;
                    this.emailError.message = this.translate('inUseMail');
                    this.jumpToError();
                } else {
                    dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                    console.error(err);
                }
                this.loading = false;
            });
        },
        onBackClick () {
            router.back();
        }
    },

    watch: {
        email () { this.emailError.state = false; },
        name () { this.nombreError.state = false; },
        sureName () { this.apellidoError.state = false; },
        password () { this.passwordError.state = false; },
        passwordConfirmation () { this.passwordError.state = false; },
        selectedZone () { this.zonasError.state = false; },
        tipoBeneficioRegistro () { this.beneficioRegistroError.state = false; }
    },

    beforeDestroy () {
        bus.off('back-click', this.onBackClick);
        let data = {};
        data.selectedZone = this.selectedZone;
        data.email = this.email;
        data.password = this.password;
        data.passwordConfirmation = this.passwordConfirmation;
        data.name = this.name;
        data.sureName = this.sureName;
        data.termsAndConditions = this.termsAndConditions;
        data.telefono = this.telefono;
        data.tipoBeneficioRegistro = this.tipoBeneficioRegistro;
        this.saveViewData({key: 'view', subKey: 'register', data: data});
    },
    components: {
        Calendar
    },
    mixins: [Forms]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .form-input-wrapper {
        margin-top: 0;
    }
    .header-logo {
        width: 100%;
        background: var(--login-background);
        padding: 2em 1em 1.6em 1em;
        text-align: center;
        margin-bottom: 2em;
        position: relative;
    }
    .header-logo img {
        max-width: 300px;
        width: 100%;
    }
    .backButton {
        position: absolute;
        top: .4em;
        left: .4em;
        cursor: pointer;
    }
    .col-container {
        padding: 0 .4em;
    }
    .terms {
        margin-top: 1.2rem;
    }
    span.error {
        display: block;
        font-size: 12px;
        margin-top: -5px;
        color: red;
        font-weight: bold;
    }
    .cbx_terms {
        display: inline;
    }
    .form {
        padding: 1em;
        margin: 0 -16px;
    }
    .terms input[type="checkbox"] {
        display: inline-block;
        vertical-align: top;
    }
    .terms label {
        display: inline-block;
        width: calc(100% - 20px);
    }
    .terms button {
        display: block;
    }
    p {
        margin-top: 0;
    }
    .help {
        margin-top: -.4em;
        margin-bottom: 1.2em;
        display: block;
    }
    .beneficio-registro-title {
        font-size: 1.1em;
        margin-bottom: 0.25em;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Register.vue